<template>
    <div class="animated fadeIn" style="width: 100%;height: 100%;">
        <router-view/>
        <div class="navBar">
            <div class="item" :class="[activeName=='index'||activeName=='index_stu'?'itemActive':'']"
                    @click="goRouter('index')">
                <img src="../assets/images/home.png" alt="">
                <img src="../assets/images/home_active.png" alt="">
                <span>首页</span>
            </div>
            <div class="item" :class="[activeName=='news'?'itemActive':'']" @click="goRouter('news')">
                <img src="../assets/images/news.png" alt="">
                <img src="../assets/images/news_active.png" alt="">
                <span>新闻</span>
            </div>
            <div class="item" :class="[activeName=='yyzx'?'itemActive':'']" @click="goRouter('yyzx')">
                <img src="../assets/images/service-center.png" alt="">
                <img src="../assets/images/service-center_active.png" alt="">
                <span>服务中心</span>
            </div>
            <div class="item" :class="[activeName=='mine'?'itemActive':'']" @click="goRouter('mine')">
                <img src="../assets/images/my.png" alt="">
                <img src="../assets/images/my_active.png" alt="">
                <span>我的</span>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import {Toast} from 'vant';

    export default {
        computed: {
            ...mapState(['memberInfo', 'roleList']),
            activeName:{
                get:function(){
                    return this.$route.path.substring(1, this.$route.path.length)
                },
                set:function(){}
            }
        },
        data() {
            return {
                // activeName: 'mine',
                showCard: false,
                userImage: '',
                userInfo: '',
                errorImg: '',
                roleType: ''
            }
        },
        mounted() {
            // this.activeName = this.$route.path.substring(1, this.$route.path.length);
            if(this.memberInfo.memberSex == 1){
                this.errorImg = 'this.src="' + require('../assets/images/man.png') + '"'
            }else if(this.memberInfo.memberSex == 2){
                this.errorImg = 'this.src="' + require('../assets/images/woman.png') + '"'
            }
        },
        methods: {
            goRouter(href) {
                // if (href == 'index') {
                //     if (this.roleList.indexOf('student') > -1) {
                //         this.activeName = 'index_stu';
                //         this.$router.push('/index_stu')
                //     } else {
                //         this.activeName = href;
                //         this.$router.push('/' + href)
                //     }
                // } else {
                //     this.activeName = href;
                //     this.$router.push('/' + href)
                // }
                this.activeName = href;
                this.$router.push('/' + href)
            }
        }
    }
</script>

<style scoped>
    .navBar {
        height: 1.2rem;
        width: 100%;
        position: fixed;
        bottom: 0;
        z-index: 10;
        box-shadow: 0px 0px 36px 7px rgba(0, 0, 0, 0.06);
        background-color: #fff;
        display: flex;
    }

    .navBar .item{
        flex:1;
        display: flex;
        flex-direction: column;
        height: 1.2rem;
        align-items: center;
        color: #999999;
        font-size:.24rem;
        padding-top:.25rem;
    }
    .navBar .itemActive{
        color:#0073FA;
    }
    .navBar .item img{
        width:.5rem;
        height: .43rem;
        margin-bottom:.1rem;
    }
    .navBar .item img:first-child{
        display: block;
    }
    .navBar .item img:nth-child(2){
        display: none;
    }
    .navBar .itemActive img:first-child{
        display: none;
    }
    .navBar .itemActive img:nth-child(2){
        display: block;
    }
    .navBar .item span {
        display: block;
        text-align: center;
    }
</style>
